module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "relevantLink",
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._t("default"), _vm._v(" "), _c('span', {
    staticClass: "relevantLink-title"
  }, [_vm._v(_vm._s(_vm.title))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2cb97a4a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/relevantlink.vue
// module id = 66
// module chunks = 0